import axios from '@/lib/axios'
import {
  buildAdminRequestConfig,
  type OrganizationId,
  type ScopedAdminQueryKey,
} from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type { ApiTokenState, ApiTokenValidationResult } from './api-tokens.types'

interface OrganizationScoped {
  organizationId: OrganizationId
}

export async function getApiToken({
  queryKey: [{ organizationId }],
}: QueryFunctionContext<ScopedAdminQueryKey>) {
  return axios.get<ApiTokenState>('/api-token', buildAdminRequestConfig({ organizationId }))
}

export async function createApiToken({ organizationId }: OrganizationScoped) {
  return axios.post<ApiTokenState>('/api-token', {}, buildAdminRequestConfig({ organizationId }))
}

export async function regenerateApiToken({ organizationId }: OrganizationScoped) {
  return axios.post<ApiTokenState>(
    '/api-token/regenerate',
    {},
    buildAdminRequestConfig({ organizationId })
  )
}

export async function validateApiToken({
  organizationId,
  token,
}: OrganizationScoped & { token: string }) {
  return axios.post<ApiTokenValidationResult>(
    '/api-token/validate',
    { token },
    buildAdminRequestConfig({ organizationId })
  )
}

export async function revokeApiToken({ organizationId }: OrganizationScoped) {
  return axios.delete<void>('/api-token', buildAdminRequestConfig({ organizationId }))
}
